import PropTypes from "prop-types"
import { FastForward, PlayArrow } from "@mui/icons-material"
import { DRIFT_STATUS } from "helpers/drift"

export default function DriftIcon({ driftId }) {
  const { VERY_LOW, LOW, NEUTRAL, HIGH, VERY_HIGH } = DRIFT_STATUS
  switch (driftId) {
    case VERY_LOW:
      return <FastForward className="components_drift-icon oversold-plus" />
    case LOW:
      return <PlayArrow className="components_drift-icon oversold" />
    case HIGH:
      return <PlayArrow className="components_drift-icon overbought" />
    case VERY_HIGH:
      return <FastForward className="components_drift-icon overbought-plus" />
    case NEUTRAL:
    default:
      return <div className="components_drift-icon empty" />
  }
}

DriftIcon.propTypes = {
  driftId: PropTypes.string.isRequired,
}
